export const PLAN_TAGS = {
    GET_PLANS: "GetPlans",
} as const;